<template>
  <div class="app">
    <baseLayout>
      <!-- <slot name="header" />に入る -->

      <template v-slot:accountingHeader></template>
      <template v-slot:businessHeader></template>

      <!-- 名前なしslotに入る -->
      <router-view />

      <!-- <slot name="footer" />に入る -->
      <template v-slot:footer>
        <div v-show="!footerFlag">
          <BopFooter v-if="bopFooterFlag"></BopFooter>
          <Footer v-else></Footer>
        </div>
      </template>

      <!-- ダイアログ定義：予閉塞確認用(メンテナンス時間30分前～一度だけ出力)  -->
      <PreOcclusionDialog
        :isShow="showFlg"
        :time="maintenanceMinutes"
        :closeType="getCloseType"
        @confirm="confirm"
      ></PreOcclusionDialog>
      <ScrollToTop />
    </baseLayout>
    <STDSDC01C03ProcessingModal></STDSDC01C03ProcessingModal>
  </div>
</template>

<script>
import moment from "moment";
import STDSDC01C03ProcessingModal from "@/components/STDSDC01C03ProcessingModal.vue";
import { mapGetters, mapState, mapMutations } from "vuex";
import baseLayout from "@/components/BaseLayout.vue";
import Footer from "@/components/Footer.vue";
import BopFooter from "@/components/BopFooter.vue";
import PreOcclusionDialog from "@/components/PreOcclusionDialog.vue";
import ScrollToTop from "@/components/ScrollToTop.vue";
import Common from "@/util/common.js";
export default {
  name: "App",
  components: {
    baseLayout,
    Footer,
    BopFooter,
    PreOcclusionDialog,
    STDSDC01C03ProcessingModal,
    ScrollToTop,
  },
  data() {
    return {
      footerFlag: false, // フッター表示．非表示
      bopFooterFlag: false, // 事業者フッター表示．非表示
      preOcclusionFlag: false, // 予閉塞ダイアログ表示．非表示
      usageCountFlag: 0, // 予閉塞ダイアログ表示回数
      overTime: "", // 閉塞時間
      maintenanceMinutes: 0, // 閉塞時間分
      showFlg: false,
      tabId: null, // タブ固有のID
      isMobile: Common.isMobile(),
    };
  },
  created() {
    if (process.env.VUE_APP_F12_ENABLE === "false") {
      document.onkeydown = function (e) {
        // disable F12 key
        if (e.key === "F12") {
          return false;
        }
      };
    }
  },
  mounted() {
    if (!this.isMobile) {
      // 初回タブかどうかを確認
        setTimeout(() => { // 非同期競合を防ぐために少し遅らせる
          const isNewTab = !performance.getEntriesByType('navigation').some((nav) => nav.type === 'reload');
          if (isNewTab) {
            this.tabId = this.generateUniqueId();
            sessionStorage.setItem("tabId", this.tabId);
            const currentTabs = this.getCurrentTabs();
            if (currentTabs.length > 0 && !currentTabs.includes(this.tabId)) {
              sessionStorage.setItem("istabId", this.tabId);
              this.$router.push({
                name: "STDSCM04C06",
                state: {
                  message: Common.getMessage("MTCL0902", []),
                },
              });
            }
          } else {
            this.tabId = sessionStorage.getItem("tabId");
          }
          const currentTabs = this.getCurrentTabs();
          if (!currentTabs.includes(this.tabId)) {
            localStorage.setItem("currentTabs", JSON.stringify([...currentTabs, this.tabId]));
          }
      }, 100); // 100ms 待機して競合回避

      // タブ閉じイベント
      window.addEventListener("beforeunload", this.handleTabClose);
    }
 
    //this.stopContextmenu();
    this.exportDialogue(false);
    this.importDialogue(false);
  },

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleTabClose);
  },

  watch: {
    maintenance: function (newVal) {
      if (newVal && newVal != "23:59" && newVal != "00:00") {
        this.preOcclusion();
      }
    },
    $route(to, from) {
      this.preOcclusionFlag =
        _.includes(
          ["STDSCM01C01", "STDSCM01C02", "STDSCM04C06", "NotFound"],
          to.name
        ) || _.eq(to.name, from.name)
          ? false
          : true;
      // 画面遷移
      if (this.preOcclusionFlag) {
        this.usageCountFlag += 1;
      }
      const pageIds = ["STDSCM04C07", "STDSCM04C06", "STDSDC01C08", "NotFound"];
      this.footerFlag = _.includes(pageIds, to.name) ? true : false;

      // 事業者Footer使う場合
      const bopIds = [
        "STDSCM01C02",
        "STDSDR01C01",
        "STDSDR01C03",
        "STDSDR01C04",
        "STDSDR01C05",
      ];

      if (_.includes(bopIds, to.name)) {
        this.bopFooterFlag = true;
      } else {
        if (this.getBusinessOperatorFlag) {
          this.bopFooterFlag = true;
        } else {
          this.bopFooterFlag = false;
        }
      }
    },
  },
  computed: {
    ...mapGetters("businessModule", ["getMaintenance", "getCloseType"]),
    ...mapState("businessModule", ["maintenance"]),
    ...mapGetters("businessOperatorModule", ["getBusinessOperatorFlag"]),
    showMaintenance() {
      return this.usageCountFlag == 1 && this.overTime != "" ? true : false;
    },
  },
  methods: {
    ...mapMutations("businessModule", ["importDialogue", "exportDialogue"]),
    // **********************************************
    // メンテナンス時間30分前～一度だけ出力
    // **********************************************
    preOcclusion() {
      // システム日付取得
      const currentDateTime = moment().format("YYYY/MM/DD HH:mm");
      // メンテナンス時間
      const maintenance = this.getMaintenance;

      let maintenanceTime = moment(maintenance, "HH:mm").format(
        "YYYY/MM/DD HH:mm"
      );
      let ms = moment(maintenanceTime, "YYYY/MM/DD HH:mm").diff(
        moment(currentDateTime, "YYYY/MM/DD HH:mm")
      );
      const result = moment.duration(ms);

      // メンテナンス時間30分前
      if (
        result.hours() == 0 &&
        result.minutes() > 0 &&
        result.minutes() <= 30
      ) {
        this.overTime = moment(maintenanceTime).format("HH:mm");
        this.maintenanceMinutes = result.minutes();
        this.showFlg = true;
        // this.usageCountFlag = 1;
      }
    },
    // **********************************************
    // ダイアログを閉じます
    // **********************************************
    confirm() {
      this.showFlg = false;
      this.$cookies.remove("preOcclusionFlag");
      this.$cookies.remove("bopPreOcclusionFlag");
    },
    // **********************************************
    // 右クリック禁止
    // **********************************************
    stopContextmenu() {
      document.oncontextmenu = function (e) {
        return false;
      };
    },

    // ユニークIDを生成
    generateUniqueId() {
      return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    },
    // 現在のタブ一覧を取得
    getCurrentTabs() {
      return JSON.parse(localStorage.getItem("currentTabs") || "[]");
    },

    // タブ閉じ時の処理
    handleTabClose() {
      const currentTabs = this.getCurrentTabs().filter((id) => id !== this.tabId && id !== null && id !== "");
      localStorage.setItem("currentTabs", JSON.stringify(currentTabs));

      if (currentTabs.length == 1 && currentTabs.includes(this.tabId)) {
        localStorage.clear();
      }
    },
  },
};
</script>

<style scoped>
@import "./assets/css/denchouhou/style.css";
@import "./assets/css/TDSDC/style.css";
</style>
